<template>
  <div id="delegate_information" style="display: none;" class="faq">
    <h2>Delegate Information</h2>

    <div class="delegates">
      <div class="delegate" v-for="(delegate, index) in delegateInformation" :key="index">
        <h3>{{delegate['companyname']}}</h3>
        <template v-for="(attribute) in displayedAttributes">
          <span v-if="delegate[attribute]" :key="index+'-'+attribute">{{delegate[attribute]}}</span>
          <br v-if="delegate[attribute]" :key="index+'-'+attribute+'-br'"/>
        </template>
          <template v-for="(keyValue) in displayedKeyValues(delegate)">
            <dt v-if="keyValue[1]" :key="index+'-'+keyValue[0]+'dt'">{{keyValue[0]}}</dt>
            <dd v-if="keyValue[1]" :key="index+'-'+keyValue[0]+'dd'">{{keyValue[1]}}</dd>
            <br :key="index+'-'+keyValue[0]+'-br'"/>
          </template>
      </div>
    </div>
  </div>
</template>


<script>
import {mapState} from "vuex";
import _ from 'lodash'
export default {
  name: 'DelegateInformation',
  data() {
    return {
      displayedAttributes: ['name_with_title', 'position', 'add1', 'add2', 'town', 'county', 'postcode']
    }
  },
  computed: {
    ...mapState(['delegateInformation'])
  },
  methods: {
    displayedKeyValues(delegate) {
      let keyValues = [
        ["T:", delegate.telno],
        ["E:", delegate.email],
        ["W:", delegate.website]
      ]

      for (const [key, value] of Object.entries(delegate['additional_information'] || {})) {
        keyValues.push([_.capitalize(key), value])
      }

      return keyValues.filter((v) => v[1])
    },
  }
}
</script>

<style lang="scss" scoped>
  @import 'include-media/dist/_include-media.scss';

  .delegates {
    display: grid;
    grid-template-columns: 1fr 1fr; /* Two columns by default */
    gap: 20px; /* Adjust the gap between items as needed */

    @include media('<1024px') {
      grid-template-columns: 1fr;
    }
  }

  .delegate {
    break-inside: avoid; /* Prevent column break anywhere inside the element */
    line-height: 12px;
    margin-bottom: 20px;
  }

  .delegate h3 {
    line-height: 20px;
    margin-bottom: 5px;
  }

  dt {
    font-weight: bold;
  }

  dd {
    margin-left: 10px;
  }

  span {
    font-size: 12px;
  }

  dd, dt {
    display: inline;
    font-size: 12px;
  }
</style>